import { trapFocus, getNextFocusableElement } from './accessibility';

document.addEventListener("DOMContentLoaded", function() {
	const ctaContainer = document.querySelector('.sticky-cta');
	const closeButton = document.querySelector('.close-button');
	const footerContainer = document.querySelector('footer#footer');

	if(!ctaContainer || !closeButton) {
		return;
	}

	const hideOnFooterSection = ctaContainer.classList.contains('hide-on-footer-section');
	const focusableElements = ctaContainer.querySelectorAll('a,button');
	
	if(!sessionStorage.getItem('hide_sticky_cta')) {
		ctaContainer.classList.remove('d-none');

		let skipToCTAButton = document.createElement('button');
		const firstElement = document.body.firstElementChild;
		const exitCTAFocus = document.getElementById('exit-sticky-cta-focus');
		const skipToFooter = document.getElementById('footer-focus-button');
		const footer = document.querySelector('footer');

		skipToCTAButton.id = 'skip-to-sticky-cta';
		skipToCTAButton.setAttribute('aria-label', 'Skip to Sticky CTA');
		skipToCTAButton.className = 'visually-hidden-focusable focusable-top-left';
		skipToCTAButton.textContent = 'Skip to Sticky CTA';
		firstElement.insertAdjacentElement('beforebegin', skipToCTAButton);

		const nextFocusableElement = getNextFocusableElement(skipToCTAButton);
		const firstFocusableFooterElement = footer.querySelector('*[tabindex="0"]');

		skipToCTAButton.addEventListener('keydown', function(event) {
			if (event.code === 'Space' || event.keyCode === 32) {
				event.preventDefault();
				focusableElements[0].focus();
				trapFocus(ctaContainer);
			}
		});

		exitCTAFocus.addEventListener('keydown', function(event) {
			if (event.code === 'Space' || event.keyCode === 32) {
				event.preventDefault();
				nextFocusableElement.focus();
			}
		});

		skipToFooter.addEventListener('keydown', function(event) {
			if (event.code === 'Space' || event.keyCode === 32) {
				event.preventDefault();
				firstFocusableFooterElement.focus();
			}
		});
	}

	closeButton.addEventListener('click', function() {
		sessionStorage.setItem("hide_sticky_cta", 'true');
		ctaContainer.classList.add('d-none');
	});

	// Hide/Show CTA in the footer section using Intersection Observer
	if(hideOnFooterSection) {
		// Do not initialize observer if CTA is already hidden via session storage
		if(sessionStorage.getItem('hide_sticky_cta')) return;
		
		const ctaShowCallback = entries => {
			entries.forEach(entry => ctaContainer.classList.toggle('d-none', entry.isIntersecting));
		};
	
		const ctaHideCallback = entries => {
			entries.forEach(entry => ctaContainer.classList.toggle('d-none', entry.isIntersecting));
		};
	
		const hideCtaObserver = new IntersectionObserver(ctaShowCallback, {threshold: 0.0});
		//I am using -99.9% to fix a bug that causes the cta to show on the footer in some scenarios
		const showCtaObserver = new IntersectionObserver(ctaHideCallback, {rootMargin: "-99.9% 0px 0px 0px", threshold: 0.0});
		hideCtaObserver.observe(footerContainer);
		showCtaObserver.observe(footerContainer);
	}
});